<template>
  <section aria-labelledby="grievance-heading">
    <div class="container mt-4 fullPage">
      <div class="row">
        <h1 id="grievance-heading" class="display-1 page-title">
          <span class="heading_bdr_btm">
           Grievance
          </span>
        </h1>
        <p><strong>Grievance Redressal / Escalation Matrix</strong></p>
        <p><span style="font-weight: 400;">If you have a grievance, you can reach out to our Support Team for assistance.</span></p>
        <h2 id="grievance-contact-heading" class="section-heading">Contact Details</h2>
        <div class="table-responsive">
        <table class="table table-bordered" aria-labelledby="grievance-contact-heading">
        <caption class="visible-caption">Grievance escalation matrix &mdash; contact persons and details</caption>
        <thead>
        <tr>
        <th scope="col">Designation</th>
        <th scope="col">Contact Person Name</th>
        <th scope="col">Address</th>
        <th scope="col">Contact No.</th>
        <th scope="col">Email ID</th>
        <th scope="col">Alternate Email</th>
        <th scope="col">Working Hours</th>
        </tr>
        </thead>
        <tbody>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Customer Care</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Goutam Sharma</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">120, Shastri Nagar, Jammu - 180004</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">+91 9271212131</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">info@growwithstocks.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mon-Fri 09 AM &ndash; 05 PM IST</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Head of Customer Care</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Goutam Sharma</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Same as above</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">+91 9271212131</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">info@growwithstocks.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mon-Fri 09 AM &ndash; 05 PM IST</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Compliance Officer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Goutam Sharma</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Same as above</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">+91 9271212131</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">info@growwithstocks.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mon-Fri 09 AM &ndash; 05 PM IST</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">CEO</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Goutam Sharma</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Same as above</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">+91 9271212131</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">info@growwithstocks.com</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Mon-Fri 09 AM &ndash; 05 PM IST</span></p>
        </td>
        </tr>
        <tr>
        <td>
        <p><span style="font-weight: 400;">Principal Officer</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Goutam Sharma</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">Same as above</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">+91 9271212131</span></p>
        </td>
        <td>
        <p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p>
        </td>
        <td><p><span style="font-weight: 400;">growwithstocks@gmail.com</span></p></td>
        <td>
        <p><span style="font-weight: 400;">Mon-Fri 09 AM &ndash; 05 PM IST</span></p>
        </td>
        </tr>
        </tbody>
        </table>
        </div>
        <h2 class="section-heading mt-4">Grievance Redressal Mechanism</h2>
        <p><strong>Contact our Support Team</strong><span style="font-weight: 400;"> via the details mentioned above. Contact: +91 9271212131, Email id: growwithstocks@gmail.com, info@growwithstocks.com </span><span style="font-weight: 400;"></span></p>
        <p><span style="font-weight: 400;">We are committed to resolving all grievances within </span><strong>7 business days</strong><span style="font-weight: 400;"> wherever possible, but no later than </span><strong>21 business days</strong><span style="font-weight: 400;"> from the date of receipt.</span><span style="font-weight: 400;"></span></p>
        <p><span style="font-weight: 400;">If unresolved within 21 business days, you escalate your concern to SEBI via the </span><strong>SCORES Portal</strong><span style="font-weight: 400;"> (SEBI Complaints Redress System).</span><span style="font-weight: 400;"><br /></span><strong>SCORES Portal:</strong><a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer"> <span style="font-weight: 400;">scores.sebi.gov.in</span><span style="font-weight: 400;"><br /><br /></span></a></p>
        <p><span style="font-weight: 400;">If still unsatisfied with the resolution provided, you may access the </span><strong>Online Dispute Resolution (ODR) Portal</strong><span style="font-weight: 400;"> for further assistance.</span><span style="font-weight: 400;"><br /></span><strong>ODR Portal:</strong><a href="https://smartodr.in" target="_blank" rel="noopener noreferrer"> <span style="font-weight: 400;">smartodr.in</span><span style="font-weight: 400;"></span></a></p>
        <p><span style="font-weight: 400;">We encourage you to reach out directly to our Support Team first, allowing us an opportunity to resolve your concerns promptly</span></p>
        <p><span style="font-weight: 400;">.</span></p>
      </div>
      
      <!-- <div class="row">
        <div class="col-md-5 col-sm-10  col-xs-12">
          <h2 class="mt-4 section-heading">
            Got a grievance/complaint for us?
          </h2>

          <form
            v-on:submit.prevent="onSubmit"
            class="mt-3"
          >
           
            <v-text-field
              v-model="name"
              :error-messages="nameErrors"
              color="black"
              label="Name (required)"
              required
              autocomplete="name"
              :aria-required="true"
              :aria-invalid="nameErrors.length > 0 ? 'true' : 'false'"
              :aria-describedby="nameErrors.length ? 'grievance-name-error' : null"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <span id="grievance-name-error" class="sr-only">{{ nameErrors[0] }}</span>

            <v-text-field
              v-model="email"
              :error-messages="emailErrors"
              color="black"
              label="Email address of your subscription(required)"
              type="email"
              required
              autocomplete="email"
              :aria-required="true"
              :aria-invalid="emailErrors.length > 0 ? 'true' : 'false'"
              :aria-describedby="emailErrors.length ? 'grievance-email-error' : null"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            ></v-text-field>
            <span id="grievance-email-error" class="sr-only">{{ emailErrors[0] }}</span>

            <v-text-field
              v-model="mobile"
              :error-messages="mobileErrors"
              color="black"
              :counter="10"
              label="Mobile (required)"
              type="tel"
              required
              autocomplete="tel"
              inputmode="numeric"
              :aria-required="true"
              :aria-invalid="mobileErrors.length > 0 ? 'true' : 'false'"
              :aria-describedby="mobileErrors.length ? 'grievance-mobile-error' : null"
              @input="$v.mobile.$touch()"
              @blur="$v.mobile.$touch()"
            ></v-text-field>
            <span id="grievance-mobile-error" class="sr-only">{{ mobileErrors[0] }}</span>

            <v-textarea
              row="5"
              color="black"
              required
              v-model="otherQuery"
              :error-messages="otherQueryErrors"
              label="Grievance details(required)"
              :aria-required="true"
              :aria-invalid="otherQueryErrors.length > 0 ? 'true' : 'false'"
              :aria-describedby="otherQueryErrors.length ? 'grievance-details-error' : null"
              @input="$v.otherQuery.$touch()"
              @blur="$v.otherQuery.$touch()"
            ></v-textarea>
            <span id="grievance-details-error" class="sr-only">{{ otherQueryErrors[0] }}</span>

           
            <div
              role="status"
              aria-live="polite"
              aria-atomic="true"
              class="sr-only"
            >{{ liveFieldError }}</div>
            <div
              role="alert"
              aria-atomic="true"
              class="sr-only"
            >{{ formErrors }}</div>
            <div
              role="alert"
              aria-atomic="true"
              class="sr-only"
            >{{ submitStatus }}</div>
            <button
              type="submit"
              class="btn btn_custom btn_contact mt-4 mb-5"
            >Submit</button>
          </form>
         <div class="scorelink">
          <a class="d-block text-left" href="https://scores.sebi.gov.in/">https://scores.sebi.gov.in/</a>
          <a class="d-block text-left mt-4" href="https://play.google.com/store/apps/details?id=com.ionicframework.sebi236330">https://play.google.com/store/apps/details?id=com.ionicframework.sebi236330</a>
          </div> 
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
  import lb from "../util/lb";

  export default {
    name: "Grievance",
    mixins: [validationMixin],
    mounted() {
      document.title = "Grievance Redressal | Grow With Stocks";
    },
    beforeDestroy() {
      if (this._announceTimer) clearTimeout(this._announceTimer);
      if (this._statusTimer) clearTimeout(this._statusTimer);
    },
    validations: {
      name: { required },
      email: { required, email },
      otherQuery: { required },
      mobile: { numeric, required, maxLength: maxLength(10) }
    },
    data() {
      return {
        name: null,
        email: null,
        mobile: null,
        level: null,
        otherQuery: null,
        liveFieldError: "",
        submitStatus: "",
        queryLevels: [
          "I am a new investor and want to know more.",
          "I am an experienced investor and want to know more",
          "Other"
        ]
      };
    },
    computed: {
      selectErrors() {
        const errors = [];
        if (!this.$v.level.$dirty) return errors;
        !this.$v.level.required && errors.push("Please select the above ");
        return errors;
      },
      mobileErrors() {
        const errors = [];
        if (!this.$v.mobile.$dirty) return errors;
        !this.$v.mobile.required && errors.push("Mobile Number is required.");
        !this.$v.mobile.maxLength && errors.push("Enter correct Mobile Number.");
        return errors;
      },
      nameErrors() {
        const errors = [];
        if (!this.$v.name.$dirty) return errors;
        !this.$v.name.required && errors.push("Name is required.");
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push("Must be valid e-mail");
        !this.$v.email.required && errors.push("E-mail is required");
        return errors;
      },
      otherQueryErrors() {
         const errors = [];
        if (!this.$v.otherQuery.$dirty) return errors;
        !this.$v.otherQuery.required && errors.push("Details are required.");
        return errors;
      },
      formErrors() {
        return [
          ...this.nameErrors,
          ...this.emailErrors,
          ...this.mobileErrors,
          ...this.otherQueryErrors
        ].join(". ");
      }
    },
    watch: {
      nameErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Name", newVal[0]);
      },
      emailErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Email", newVal[0]);
      },
      mobileErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Mobile", newVal[0]);
      },
      otherQueryErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Grievance details", newVal[0]);
      }
    },
    methods: {
      announceError(label, msg) {
        // NVDA reliably reads live-region changes only when the DOM mutation
        // is split across paint cycles. $nextTick is a single microtask and is
        // sometimes coalesced away, so use a real timeout to guarantee NVDA
        // sees an empty-then-populated transition. Prefixing the field label
        // ensures the user knows which field, since focus has typically moved
        // to the next field by the time NVDA gets to speak the polite region.
        if (this._announceTimer) clearTimeout(this._announceTimer);
        this.liveFieldError = "";
        this._announceTimer = setTimeout(() => {
          this.liveFieldError = `${label}: ${msg}`;
        }, 100);
      },
      announceStatus(msg) {
        // role=alert announces immediately. Clear-then-set via timeout so the
        // same message (e.g. resubmit after the success message dismisses)
        // is announced again instead of being deduped by NVDA.
        if (this._statusTimer) clearTimeout(this._statusTimer);
        this.submitStatus = "";
        this._statusTimer = setTimeout(() => {
          this.submitStatus = msg;
        }, 100);
      },
      async onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          try {
            const response = await lb.post("/api/Messages/sendContactUsDetails", {
              contactInfo: {
                name: this.name,
                level: this.level,
                otherQuery: 'Grievance - ' + this.otherQuery || "",
                email: this.email,
                mobile: this.mobile
              }
            });
            this.$v.$reset();
            this.name = null;
            this.email = null;
            this.mobile = null;
            this.level = null;
            this.otherQuery = null;
            this.announceStatus("Thanks for your query, we will contact you shortly.");
            this.$toasted.show(
              "Thanks for your query, we will contact you shortly.",
              {
                duration: 5000,
                position: "bottom-right"
              }
            );
          } catch (err) {
            console.log(err);
            this.announceStatus("Submission failed. Please try again.");
            this.$toasted.show("Oops some error occurred", {
              duration: 2000,
              position: "bottom-right"
            });
          }
        } else {
          this.announceStatus("Please correct the errors above and try again.");
        }
      }
    }
  };
</script>

<style style="scss" scoped>
  .btn_custom {
    background-color: #1a7055 !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
    width: auto;
  }
  .btn_custom:hover,
  .btn_custom:focus {
    background-color: #0d3d2e !important;
  }
  .btn_custom:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
    /* Pair amber with dark halo so focus is visible on dark green button fill. */
    box-shadow:
      0 0 0 2px #0d3d2e,
      0 0 0 7px rgba(13, 61, 46, 0.55),
      0 8px 18px rgba(13, 61, 46, 0.28);
  }
  .page-title {
    text-align: center;
    color: #1a1a1a;
    font-weight: 700;
    margin-bottom: 24px;
  }
  .section-heading {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a1a;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  th[scope="col"] {
    background: #f1f1f1;
    color: #1a1a1a;
    font-weight: 700;
  }
  table caption.sr-only {
    caption-side: top;
  }
  /* WCAG 1.3.1 — visible table caption so it's reliably announced and seen */
  .visible-caption {
    caption-side: top;
    text-align: left;
    padding: 8px 4px;
    font-weight: 600;
    font-size: 16px;
    color: #2d2d2d;
    background: transparent;
  }
  /* .heading_bdr_btm {
          padding-bottom: 5px;
          border-bottom: 3px #31cc9a solid;
        } */
  .fullPage {
    min-height: 100vh;
  }
  td {
    padding: 13px;
  }
  ul {
    list-style: none;
  }
  li {
    display: inline;
  }
  #contactus_social {
    padding: 0;
  }
  h3 {
    text-align: center;
    margin-bottom: 50px;
  }
  .scorelink{
    margin-top:100px;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    .btn_contact {
      display: block;
      margin: auto;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }
</style>



// WEBPACK FOOTER //
// src/views/Grievance.vue